import type { LeaveReason } from '../net/leaveReason'

/** Menu error lines (short, for players aged 10+). */
const ERRORS: Record<LeaveReason, string> = {
  'not-found': 'No room with that code. Check the letters and try again.',
  full: 'That room is full or its race has already started.',
  auth: 'Sign-in failed. Reload the page and try again.',
  duplicate: 'You are already in this race in another tab.',
  kicked: 'You were removed from the race.',
  lost: 'Connection lost during the race.',
  network: "Can't reach the game server. Check your internet and try again.",
}

export function errorText(reason: LeaveReason): string {
  return ERRORS[reason]
}

/** `1st`, `2nd`, `3rd`, `4th`. */
export function ordinal(n: number): string {
  const tens = n % 100
  if (tens >= 11 && tens <= 13) return `${n}th`
  return `${n}${['th', 'st', 'nd', 'rd'][n % 10] ?? 'th'}`
}

/** Finish time `m:ss.cc`. */
export function finishTime(ms: number): string {
  const cs = Math.floor(ms / 10)
  const m = Math.floor(cs / 6000)
  const s = Math.floor((cs % 6000) / 100)
  return `${m}:${String(s).padStart(2, '0')}.${String(cs % 100).padStart(2, '0')}`
}
